import React, { Fragment, ReactElement, useEffect } from 'react';

import { OptionsObject, SnackbarMessage, useSnackbar } from 'notistack';

export const EnqueueSnackbar: React.FC<{
	message: SnackbarMessage;
	options?: OptionsObject;
}> = ({ message, options, children }) => {
	const { enqueueSnackbar } = useSnackbar();
	useEffect(() => {
		enqueueSnackbar(message, options);
	}, [enqueueSnackbar, message, options]);
	return <>{children}</>;
};
